<template>
    <el-drawer title="抖音达人带货详细数据" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        append-to-body @close="close">
        <div class="drawer-content" v-loading="listLoading">
            <el-row :gutter="30">
                <el-col :span="12">
                    <label class="color-info">达人：</label>{{itemData && itemData.name}}
                </el-col>
                <el-col :span="12">
                    <label class="color-info">数据更新时间：</label>{{detailData && detailData.date}}
                </el-col>
            </el-row>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                    <el-table-column prop="contentOpenId" label="加密过的短视频/直播 Open ID" min-width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="playCnt" label="短视频/直播 ID"></el-table-column>
                    <el-table-column prop="contentType" label="内容形式">
                        <template slot-scope="{row} = scope">
                            {{contentType[row.contentType]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="playCnt" label="观众人数"></el-table-column>
                    <el-table-column prop="gmv" label="带货销售额"></el-table-column>
                    <el-table-column prop="talentCommission" label="佣金金额"></el-table-column>
                    <el-table-column prop="usedGmv" label="已核销销售额"></el-table-column>
                </el-table>
            </div>
            <div v-if="detailData" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="detailData.totalCount || 0">
                </el-pagination>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    id: "",
    douyinId: ""
}

export default {
	
    data(){
        return{
            drawerShow: false,
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
            itemData: null,
            detailData: null
        }
    },
    computed:{
        contentType(){
            return{
                1:'短视频', 2:'直播间', 3:'短视频和直播间'
            }
        }
    },
    methods: {
        close() {
            this.drawerShow = false;
            this.params = {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            }
        },
        show(id, detailData) {
            this.params.id = id;
            this.itemData = detailData;
            this.getDataList();
            this.drawerShow = true;
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/cps/userDetailList",
                method: "POST",
                params: {
                    ...this.params,
                    douyinId: this.itemData.douyinId,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if ( state == 1 && result ) {
                        this.detailData = result;
                        this.data = result.list;
                        this.dataList = this.data.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
						this.listLoading = false;
                    }
                })
               
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>